import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=74513cd7&"
import script from "./ThankYou.vue?vue&type=script&lang=js&"
export * from "./ThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74513cd7', component.options)
    } else {
      api.reload('74513cd7', component.options)
    }
    module.hot.accept("./ThankYou.vue?vue&type=template&id=74513cd7&", function () {
      api.rerender('74513cd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/ThankYou.vue"
export default component.exports